import { _ } from "libs";

import React, { useContext, useEffect } from "react";
import Timeline from "../components/timeline";
import FavoriteClubs from "../components/favoriteClubs";
import CourtForm from "../components/courtFinder/courtForm";
import SeasonStats from "../components/seasonStats";
import BuddiesWidget from "../components/buddiesWidget";
import UpcomingReservations from "../components/upcomingReservations";
import AdWidget from "../components/adWidget";
import ErrorBoundary from "../components/errorBoundary";
import UserContext from "../contexts/userContext";
import { AdLocation } from "../types";
import { getLocalMomentInZone } from "../libs/time";
import { RouteChildrenProps } from "react-router";

const Dashboard = ({ history }: RouteChildrenProps) => {
	const { profile, location } = useContext(UserContext);

	const timestamp = getLocalMomentInZone(profile.timeZone)
		.add(1, "h")
		.unix();

	return (
		<div className="dashboardPage">
			<div className="wrap">
				<div className="contentWrapper leftWider">
					<div className="contentLeft">
						<div className="dBlock searchCourtsWidget">
							<h5>{_("courtForm.heading")}</h5>
							<CourtForm
								history={history}
								sport={profile.sport || "tennis"}
								showSubmitButton={true}
								city={profile.city || location.city}
								timezone={profile.timeZone}
								timestamp={timestamp}
							/>
						</div>
						<UpcomingReservations />
						<Timeline />
					</div>
					<div className="contentRight">
						<ErrorBoundary>
							<SeasonStats />
						</ErrorBoundary>
						<AdWidget location={AdLocation.DashboardSidebar} className="aBlock" />
						<FavoriteClubs />
						<BuddiesWidget />
					</div>
				</div>
			</div>
		</div>
	);
};

export default Dashboard;
